import { AxiosError } from "axios";

export class UnauthenticatedUserError extends Error {}

export class ProgrammingError extends Error {}

export class UnexpectedError extends AxiosError {}
